import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Stamp</h2>
          </div>

          <Grid container spacing={1} className="stamp-grid">
            <Grid item>
              <div className="stamp on" />
            </Grid>
            <Grid item>
              <div className="stamp on" />
            </Grid>
            <Grid item>
              <div className="stamp on" />
            </Grid>
            <Grid item>
              <div className="stamp on" />
            </Grid>
            <Grid item>
              <div className="stamp on">
                <span className="benefit">
                  <img src={`${process.env.PUBLIC_URL}/images/icon/file.svg`} />
                </span>
              </div>
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp">
                <span className="benefit">
                  <img src={`${process.env.PUBLIC_URL}/images/icon/file.svg`} />
                </span>
              </div>
            </Grid>
          </Grid>

          <Accordion
            codemirror={codemirror === "Stamp"}
            onChange={handleCodemirror("Stamp")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Grid container spacing={1} className="stamp-grid">
  <Grid item>
    <div className="stamp on" />
  </Grid>
  <Grid item>
    <div className="stamp on" />
  </Grid>
  <Grid item>
    <div className="stamp on" />
  </Grid>
  <Grid item>
    <div className="stamp on" />
  </Grid>
  <Grid item>
    <div className="stamp on">
      <span className="benefit">
        <img src={${process.env.PUBLIC_URL}/images/icon/file.svg} />
      </span>
    </div>
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp">
      <span className="benefit">
        <img src={${process.env.PUBLIC_URL}/images/icon/file.svg} />
      </span>
    </div>
  </Grid>
</Grid>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <Grid
            container
            spacing={1}
            className="stamp-grid"
            justifyContent="center"
          >
            <Grid item />
            <Grid item>
              <div className="stamp on" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item />

            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp">
                <span className="benefit">
                  <img src={`${process.env.PUBLIC_URL}/images/icon/file.svg`} />
                </span>
              </div>
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp">
                <span className="benefit">
                  <img src={`${process.env.PUBLIC_URL}/images/icon/file.svg`} />
                </span>
              </div>
            </Grid>

            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp" />
            </Grid>
            <Grid item>
              <div className="stamp">
                <span className="benefit">
                  <img src={`${process.env.PUBLIC_URL}/images/icon/file.svg`} />
                </span>
              </div>
            </Grid>
          </Grid>

          <Accordion
            codemirror={codemirror === "Stamp2"}
            onChange={handleCodemirror("Stamp2")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Grid
  container
  spacing={1}
  className="stamp-grid"
  justifyContent="center"
>
  <Grid item />
  <Grid item>
    <div className="stamp on" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item />

  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp">
      <span className="benefit">
        <img src={${process.env.PUBLIC_URL}/images/icon/file.svg} />
      </span>
    </div>
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp">
      <span className="benefit">
        <img src={${process.env.PUBLIC_URL}/images/icon/file.svg} />
      </span>
    </div>
  </Grid>

  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp" />
  </Grid>
  <Grid item>
    <div className="stamp">
      <span className="benefit">
        <img src={${process.env.PUBLIC_URL}/images/icon/file.svg} />
      </span>
    </div>
  </Grid>
</Grid>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
